import { Star } from 'lucide-react';
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { cn } from "@/lib/utils";

const testimonials = [
  {
    id: 1,
    quote: "This tool has revolutionized our hiring process. We're making better decisions faster than ever.",
    author: "Sarah Johnson",
    role: "Head of Recruitment, TechCorp Inc.",
    rating: 5
  },
  {
    id: 2,
    quote: "The smart analysis is incredibly accurate. It helps us identify the best candidates quickly and efficiently.",
    author: "Michael Chen",
    role: "Technical Recruiter, Innovation Labs",
    rating: 5
  },
  {
    id: 3,
    quote: "The interview suggestions are spot-on. It's like having an expert recruiter guiding you through the process.",
    author: "Emma Williams",
    role: "HR Director, Global Solutions",
    rating: 5
  }
];

export function Testimonials() {
  return (
    <div className="bg-gradient-to-b from-background to-muted/40 py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 sm:mb-20">
           <h2 className={cn(
              "text-sm font-semibold tracking-wide uppercase mb-2",
              "text-primary"
          )}>
            Testimonials
          </h2>
          <p className="mt-1 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-foreground">
            What Our Users Say
          </p>
           <p className="mt-4 max-w-2xl text-lg text-muted-foreground mx-auto">
             Hear from professionals who transformed their recruitment workflow.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          {testimonials.map((testimonial) => (
            <Card 
                key={testimonial.id}
                className="flex flex-col bg-card/80 backdrop-blur-sm border border-border/60 shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <CardHeader className="pb-4">
                 <div className="flex space-x-0.5 text-yellow-400">
                    {[...Array(5)].map((_, i) => (
                        <Star 
                           key={i} 
                           className={cn(
                               "h-4 w-4",
                               i < testimonial.rating ? 'fill-current' : 'fill-muted opacity-40'
                           )}
                           aria-hidden="true" 
                        />
                    ))}
                </div>
              </CardHeader>
              <CardContent className="flex-grow">
                <blockquote className="text-base text-foreground italic border-l-2 border-primary pl-4 py-1">
                   <p>"{testimonial.quote}"</p>
                </blockquote>
              </CardContent>
              <CardFooter className="mt-4 pt-4 border-t border-border/60">
                <div>
                    <p className="text-sm font-semibold text-foreground">{testimonial.author}</p>
                    <p className="text-xs text-muted-foreground">{testimonial.role}</p>
                </div>
              </CardFooter>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}